const config = {
  sanity: {
    projectId: 'bvcjw1gn',
    dataset: 'production'
  }
}

export default config;
